<template>
<!--This is the dropdown main filter feature that filter
  through the listing of instruments based on a research area.
  The default value is 'axial-base.-->
  <b-row style="height: 100%;">
    <b-col class="h-100" cols="12">
      <b-row id="v-step-2" style="height: 30%;">
        <b-col class="h-100">
          <span style="color: black; font-weight: bold"
            >Research Area &nbsp;</span
          >
          <i
            class="fas fa-info-circle"
            v-b-popover.hover.bottom="
              'Select a research area of interest by clicking one below.'
            "
            title="Select a Research Area"
          ></i>
          <b-form-select
            id="site-dropdown"
            v-model="selectedArea"
            :options="areaList"
            :disabled="instSelectedCount > 0"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>
                -- Select a research area --
              </b-form-select-option>
            </template>
            <!--Below is code to include an 'all sites' selection-->
            <!-- <b-form-select-option
              :value="`all-sites`">
              All sites
            </b-form-select-option> -->
          </b-form-select>
          <b-img
            :id="`${selectedArea}-traceid`"
            v-b-modal="`${selectedArea}-traceid`"
            :src="areaImagesMap[selectedArea]"
            rounded="0"
            thumbnail
          ></b-img>
        </b-col>
        <!--Modal to expand research area image for user-->
        <b-modal
          :id="`${selectedArea}-traceid`"
          size="xl"
          header-class="lightbox-header"
          body-class="lightbox-body"
          content-class="lightbox-modal-content"
          hide-footer
          centered
        >
          <b-container fluid style="padding: 0">
            <b-row>
              <b-col cols="12" class="text-center">
                <b-img
                  :src="areaImagesMap[selectedArea]"
                  fluid
                  :alt="selectedArea"
                >
                </b-img>
              </b-col>
            </b-row>
          </b-container>
        </b-modal>
      </b-row>
      <b-row id="v-step-3" style="height: 70%;">
        <b-col class="h-100">
          <b-row style="height: 100%;" class="flex-column justify-content-center">
            <b-col class="h-100" style="overflow-y: auto;">
              <span style="color: black; font-weight: bold">
                Filter List of Instruments&nbsp;
              </span>
              <i
                class="fas fa-info-circle"
                v-b-popover.hover.bottom="filterHoverContent"
                title="Filter the list of instruments"
              ></i>
              <!--The component that holds the filter
              functionality. This will filter through the listing
              of instruments by infrastructure and data groups.-->
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header
                    v-b-toggle.accordion-2
                    style="cursor: pointer; color: white;"
                    header-tag="header"
                    class="p-1 d-flex justify-content-between align-items-center"
                    role="tab"
                    header-bg-variant="primary"
                    v-on:click="infraRotation()"
                  >
                    <b-button
                      variant="link"
                      style="text-decoration: none; color: white;"
                    >Infrastructures</b-button>
                    <i
                      class="p-3 fas fa-angle-up transition"
                      v-bind:style="{transform: `rotate(${infraDeg}deg)`}" alt="refresh-icon-btn">
                    </i>
                  </b-card-header>
                  <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-form-group>
                        <b-form-checkbox-group
                          id="checkbox-group-2"
                          v-model="selectedInfra"
                          :options="infraCheckboxes"
                          name="flavour-2"
                          class="p-0"
                        ></b-form-checkbox-group>
                      </b-form-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header
                    v-b-toggle.accordion-1
                    style="cursor: pointer; color: white;"
                    header-tag="header"
                    class="p-1 d-flex justify-content-between align-items-center"
                    role="tab"
                    header-bg-variant="primary"
                    v-on:click="instRotation()"
                  >
                    <b-button
                      variant="link"
                      style="text-decoration: none; color: white;"
                    >Instruments</b-button>
                    <i
                      class="p-3 fas fa-angle-up transition"
                      v-bind:style="{transform: `rotate(${instDeg}deg)`}" alt="refresh-icon-btn">
                    </i>
                  </b-card-header>
                  <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <b-form-checkbox-group
                        id="checkbox-group-3"
                        v-model="selectedInst"
                        :options="instrumentCheckboxes"
                        name="flavour-3"
                        class="p-0"
                      ></b-form-checkbox-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import _ from 'lodash';
import { mapActions, mapState, mapGetters } from 'vuex';
import { AREA_IMAGES_MAP } from '../../../utils/constants';

export default {
  props: {
    area: {
      type: String,
    },
    infrastructure: {
      type: String,
    },
    instrument: {
      type: String,
    },
  },
  data() {
    return {
      areaImagesMap: AREA_IMAGES_MAP,
      areaList: [{ value: null, text: 'Please select some item' }],
      selectedArea: '',
      selectedInfra: [], // Selections must be an array reference!
      selectedInst: [], // Selections must be an array reference!
      // siteCheckboxes: [],
      filteredInstruments: [],
      filteredGroups: {},
      infraCheckboxes: [],
      // dataProductsCheckboxes: [],
      collapses: [
        // { show: true, name: 'Site' }, // site filter starts open, not closed
        { show: true, name: 'Instrument' },
        { show: false, name: 'Infrastructure' },
      ],
      filterHoverContent:
        'Select an instrument or infrastructure of interest by clicking one below.',
      tabIndex: 0,
      instDeg: 0,
      infraDeg: 180,
      checked: true,
    };
  },
  mounted() {
    this.selectedArea = this.area; // from the prop
    this.areaList = this.filteredAreas();
    this.filterSites(); // to update filter based on w/ default area

    this.selectedInfra = this.infrastructure.split(',').filter(Boolean);
    this.selectedInst = this.instrument.split(',').filter(Boolean);
  },
  computed: {
    // Gets the posts that are in the store
    ...mapState({
      instruments: (state) => state.instruments,
      infrastructures: (state) => state.infrastructures,
      sites: (state) => state.sites.features,
      researchAreas: (state) => state.areas.features,
    }),
    ...mapState('visualization', {
      filterSelectedArea: (state) => state.filterSelectedArea,
      filterSelectedSite: (state) => state.filterSelectedSite,
      filterSelectedInfra: (state) => state.filterSelectedInfra,
      filterSelectedInst: (state) => state.filterSelectedInst,
    }),
    ...mapGetters('visualization/charts', {
      getChart: 'find',
      charts: 'list',
      chartsLength: 'count',
    }),
    uuid() {
      return this.$route.params.id;
    },
    chart() {
      if (this.chartsLength === 0) {
        return null;
      }
      return this.getChart(this.uuid);
    },
    instSelectedCount() {
      // Gets the count of selected Instruments from chart
      if (!this.chart) {
        return 0;
      }

      if (this.chart.chart.data.length === 0) {
        return 0;
      }
      // Get's the first data everytime
      // This will have to change with multiple traces
      return this.chart.chart.data[0].selectedInstruments.length;
    },
    // Gets the formal area name from the area endpoint
    areaName() {
      return _.find(this.researchAreas, [
        'properties.reference_designator', this.$route.query.area,
      ]).properties.area_name;
    },
    instrumentCheckboxes() {
      let groupedCodes = null;
      if (this.selectedInfra.length > 0) {
        const selectedFiltered = _.filter(
          this.filteredInstruments,
          (v) => _.includes(this.selectedInfra, v.infra_rd),
        );
        groupedCodes = _.groupBy(selectedFiltered, 'group_code');
      } else {
        groupedCodes = _.groupBy(this.filteredInstruments, 'group_code');
      }
      const mappedInstListing = _.uniqBy(this.filteredInstruments, 'group_code').map((feat) => {
        let count = 0;
        if (feat.group_code in groupedCodes) {
          count = groupedCodes[feat.group_code].length;
        }
        if (count === 0) {
          if (this.selectedInst.includes(feat.group_code)) {
            this.selectedInst = this.selectedInst.filter((i) => i !== feat.group_code);
          }
        }
        return {
          text: `${feat.group_code}: ${feat.name} [${count}]`,
          value: feat.group_code,
          disabled: count === 0,
        };
      });
      // Puts list in alphabetical order
      return _.sortBy(mappedInstListing, ['text']);
    },
  },
  watch: {
    $route(to, from) {
      if ('area' in to.query) {
        this.selectedArea = to.query.area;
      }
      // react to route changes...
      if (to.path !== from.path) {
        this.refreshFromChange(to.query);
      } else if ('reset' in to.query) {
        this.$router.push({ query: { area: 'axial-base' } });
        this.refreshFromChange(to.query);
      }
    },
    /**
     * A watcher for the selected area. If the selection is updated,
     * the instrument listing gets updated with a new filtered listings.
     * @param {string} newVal - New value of selected area
     * @param {string} oldVal - Old value of selected area
     */
    selectedArea(newVal, oldVal) {
      if (newVal) {
        let query = {
          ...this.$route.query,
          area: newVal,
        };
        if (oldVal !== newVal) {
          if (oldVal !== '') {
            query = {
              area: newVal,
              d: this.$route.query.d ? this.$route.query.d : null,
            };
            this.resetSelections();
          }
          this.$router.push({ query }).catch((err) => err);
          /** Store area query to chart object */
          this.updateChartQuery({ uuid: this.uuid, query });
          /** Method to update the filter listing whenever new area is selected */
          this.filterSites();
        }
      }
    },
    /**
     * A watcher for the selected infra checkboxes. As the user selects infras
     * to filter by, the information gets saved and updated in the store which
     * is used in InstrumentCards.vue.
     * @param {string} newVal - New value of selected infrastructure
     */
    selectedInfra(newVal) {
      if (newVal) {
        let query = { ...this.$route.query };
        if (newVal.length === 0) {
          if (_.has(this.$route.query, 'infrastructure')) {
            query = _.omit(query, 'infrastructure');
          }
        } else {
          query = {
            ...query,
            infrastructure: newVal.join(','),
          };
        }
        this.$router.push({
          query,
        }).catch((err) => err);
        this.updateChartQuery({ uuid: this.uuid, query });
      }
    },
    /**
     * A watcher for the selected inst checkboxes. As the user selects insts
     * to filter by, the information gets saved and updated in the store which
     * is used in InstrumentCards.vue.
     * @param {string} newVal - New value of selected instrument
     */
    selectedInst(newVal) {
      if (newVal) {
        let query = { ...this.$route.query };
        if (newVal.length === 0) {
          if (_.has(this.$route.query, 'instrument')) {
            query = _.omit(query, 'instrument');
          }
        } else {
          query = {
            ...query,
            instrument: newVal.join(','),
          };
        }
        this.$router.push({
          query,
        }).catch((err) => err);
        this.updateChartQuery({ uuid: this.uuid, query });
      }
    },
  },
  methods: {
    ...mapActions('visualization/charts', [
      'updateChartQuery',
      'selectChartArea',
    ]),
    instRotation() {
      this.instDeg += 180;
    },
    infraRotation() {
      this.infraDeg += 180;
    },
    resetInfra() {
      if (!_.isEmpty(this.selectedInfra)) {
        this.selectedInfra = [];
      }
    },
    resetInst() {
      if (!_.isEmpty(this.selectedInst)) {
        this.selectedInst = [];
      }
    },
    /** Creates the list of research areas in dropdown */
    filteredAreas() {
      const filterAreas = _.filter(
        this.researchAreas,
        (o) => o.properties.reference_designator !== 'mid-plate',
      );
      return _.sortBy(
        filterAreas.map((feat) => {
          const siteRef = feat.properties.reference_designator;
          return {
            text: feat.properties.area_name,
            value: siteRef,
          };
        }),
        ['text'],
      );
    },
    /**
     * Resets all the selected sites, infra, and inst whenever
     * the user switches between different filter groupings.
     */
    resetSelections() {
      if (!_.isEmpty(this.selectedInfra)) {
        this.selectedInfra = [];
      }
      if (!_.isEmpty(this.selectedInst)) {
        this.selectedInst = [];
      }
    },
    /**
     * This takes the saved site information from the store, then maps
     * each site name to the checkbox text and their reference designator
     * to the checkbox value.
     */
    filterSites() {
      const sitesData = this.sites;
      const siteNames = [];
      let mappedSiteListing = [];
      // Gets all the site objects that are within a research area
      sitesData.forEach((o) => {
        if (o.properties.area_rd === this.$route.query.area) {
          siteNames.push(o);
        }
      });
      // Maps the checkbox texts and values
      mappedSiteListing = siteNames.map((feat) => ({
        text: feat.properties.site_name,
        value: feat.properties.reference_designator,
        disabled: false,
      }));
      // Removes any duplicates
      const rmSiteDuplicates = _.uniqBy(mappedSiteListing, 'value');
      // Puts list in alphabetical order
      const sortSiteList = _.sortBy(rmSiteDuplicates, ['text']);
      this.filterInfrastructure(rmSiteDuplicates);
      this.siteCheckboxes = sortSiteList;
    },
    /**
     * This takes the saved infra information from the store, then maps
     * each infra name to the checkbox text and their reference designator
     * to the checkbox value.
     * @param {Array} siteListing - Array of sites objects
     */
    filterInfrastructure(siteListing) {
      const infraData = this.infrastructures;
      const infraNames = [];
      siteListing.forEach((siteVal) => {
        infraData.forEach((infraFeat) => {
          if (infraFeat.reference_designator.includes(siteVal.value)) {
            infraNames.push(infraFeat);
          }
        });
      });
      /** Filters out all the objects that do not have data */
      const filterInfraNames = _.filter(infraNames, (o) => o.has_data !== false);
      const mappedInfraListing = filterInfraNames.map((feat) => ({
        text: feat.name,
        value: feat.reference_designator,
        disabled: false,
      }));
      /** Removes any duplicates */
      const rmInfraDuplicates = _.uniqBy(mappedInfraListing, 'value');
      /** Puts list in alphabetical order */
      const sortInfraList = _.sortBy(rmInfraDuplicates, ['text']);
      this.filterInstruments(rmInfraDuplicates);
      this.infraCheckboxes = sortInfraList;
    },
    /**
     * This takes the saved inst information from the store, then maps
     * each infra name to the checkbox text and their reference designator
     * to the checkbox value.
     * @param {Array} infraListing - Array of infrastructure objects
     */
    filterInstruments(infraListing) {
      const instData = this.instruments;
      const instNames = [];
      infraListing.forEach((infraVal) => {
        instData.forEach((instFeat) => {
          if (infraVal.value === instFeat.infra_rd) {
            instNames.push(instFeat);
          }
        });
      });
      this.filteredInstruments = instNames.map((o) => ({
        ref: o.reference_designator,
        infra_rd: o.infra_rd,
        name: o.formal_name,
        group_code: o.group_code,
      }));
    },
    refreshFromChange(query) {
      this.selectedArea = query.area;
      this.areaList = this.filteredAreas();
      this.filterSites(); // to update filter based on w/ default area
      this.resetSelections();
      if ('infrastructure' in query) {
        this.selectedInfra = this.infrastructure.split(',').filter(Boolean);
      }

      if ('instrument' in query) {
        this.selectedInst = this.instrument.split(',').filter(Boolean);
      }
    },
  },
};
</script>
<style scoped>
.instrument-filter-container {
  padding: unset;
  margin: none;
  border: none;
}
.icon-rotate {
  transform: rotate(180deg);
}
.transition{
    transition: transform 0.25s ease-in-out;
}
</style>
